var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtiquette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.545,
    cy: 71.079,
    rx: 6.6857,
    ry: 6.5283,
    stroke: "#EE7203",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.545,
    cy: 48.47,
    rx: 6.6857,
    ry: 6.5283,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.545,
    cy: 25.86,
    rx: 6.6857,
    ry: 6.5283,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.337 25.418h39.119",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.337 47.829h39.119",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.337 70.241h39.119",
    style: {
      paintOrder: "stroke fill markers"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtiquette);
export default __webpack_public_path__ + "static/media/etiquette.8026589d5ac92fae4dc2f21090fd4ada.svg";
export { ForwardRef as ReactComponent };